import { defineRecipe } from '@chakra-ui/react'

const outline = {
    outline: '1px solid',
    outlineColor: 'dark.700',
    outlineOffset: 0,
}

export const textareaRecipe = defineRecipe({
    variants: {
        variant: {
            gsk: {
                boxSizing: 'border-box',
                backgroundColor: 'transparent',
                borderRadius: '4px',
                border: '1px solid',
                borderColor: { _light: 'dark.700', _dark: 'surface.default' },
                fontSize: '16px',
                color: { _light: 'dark.700', _dark: 'white' },
                paddingLeft: '16px',
                minHeight: '56px',
                _placeholder: {
                    color: {
                        _light: 'dark.500',
                        _dark: 'white',
                    },
                },
                _active: {
                    ...outline,
                },
                _focus: {
                    ...outline,
                },
                _focusVisible: {
                    ...outline,
                },
            },
        },
    },
})
